// extracted by mini-css-extract-plugin
module.exports = {"footer":"Sqeluk0F flex justify-end","cancel":"_3joVxMk1 mr2","text-field":"_2y9qb-Va mb2","textField":"_2y9qb-Va mb2","email":"_2BW3bAGQ"};